import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { CONFIG_OVERLAY_ENABLED } from '@aipb/util/di';

@Component({
  selector: 'fr-overlay-manager-button',
  imports: [MatButtonModule, MatIconModule, TranslocoModule],
  templateUrl: './overlay-manager-button.component.html',
  styleUrls: ['./overlay-manager-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverlayManagerButtonComponent {
  @Output() action = new EventEmitter();
  enabled = inject(CONFIG_OVERLAY_ENABLED);
}
